/**********************************************************
Chemical View
**********************************************************/
import FAQCard from './faq_card';
import { fetchChemicals } from '../../actions/chem_actions';
import { fetchManagers } from '../../actions/utils_actions';
import { setDocs } from '../../actions/docs_actions';
import { FAQS, CULTIVATION_URLS } from '../../cult_constants';
import { browserHistory } from 'react-router';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
const $ = window.$;

class CultivationIntro extends Component {
  componentDidMount() {
    if (this.props.managers.length === 0) this.props.fetchManagers();
    if (this.props.chemicalList.length === 0) this.props.fetchChemicals();
    document.title = 'Cultivation';
    $(document).ready(function(){
      $('#cult-faq-data').collapsible();
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    $(document).ready(function(){
      $('#cult-faq-data').collapsible();
    });
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="col s12">
            <div className="card z-depth-1 cult-intro-header">
              <div className="card-content">
                <p>Welcome to the Cultivation Module</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {
            FAQS.map((f) => (
              <FAQCard key={f.title} faq={f} _class={"pointer"} onClick={this.props.setDocs} />
            ))
          }
          <div className="col s12 m3 l3">
            <div className="card">
              <div className="card-content">
                <span className="card-title">Components</span>
                <div className="category-list">
                  {
                    CULTIVATION_URLS.map((c) => (
                      <p key={c.url} className="mt-4 pointer" onClick={() => browserHistory.push(c.url)}>
                        <i className={`material-icons vertical-text-sub ${c.iconColor}`}>panorama_fish_eye</i>
                         <span className="ml-2">{ c.name }</span>
                      </p>
                    ))
                  }
                </div>
                <span className="card-title mt-10">Managers</span>
                { this.props.managers ?
                    this.props.managers.map((m) => (
                      <div key={m.id} className="row">
                        <div className="col s3 m4 l3 xl3 pr-0">
                          <i className={`material-icons medium manager-icon`}>face</i>
                        </div>
                        <div className="col s9 m8 l9 xl9 pl-0">
                          <a href={`mailto:${m.email}`}>{ m.firstName } { m.lastName }</a>
                          <p className="text-sm">{ m.location === '71' ? `Ka'u` : `Kea'au` } - { m.positionTitle }</p>
                        </div>
                      </div>
                    ))
                  : 'N/A'
                }
              </div>
            </div>
          </div>
          <div className="col s12 m9 l9 xl9">
          {
            this.props.docs.selected ?
              <div className="card">
                {/*
                  <span className="card-title">{ this.props.docs.selectedDocs }</span>
                  <ul id={'cult-faq-data'} className="collapsible" data-collapsible="accordion">
                    <li>
                      <div className="collapsible-header"><i className="material-icons">filter_drama</i>First</div>
                      <div className="collapsible-body"><span>Lorem ipsum dolor sit amet.</span></div>
                    </li>
                    <li>
                      <div className="collapsible-header"><i className="material-icons">place</i>Second</div>
                      <div className="collapsible-body"><span>Lorem ipsum dolor sit amet.</span></div>
                    </li>
                    <li>
                      <div className="collapsible-header"><i className="material-icons">whatshot</i>Third</div>
                      <div className="collapsible-body"><span>Lorem ipsum dolor sit amet.</span></div>
                    </li>
                  </ul>
                */}

              </div>
            : <div className="card">
                <span className="cult-about-services">About the Services</span>
                <div className="card-content">
                  <div className="row">
                    <div className="col s12">
                      <ul>
                        <li><b>Product Management:</b> Manage information about the products used in cultivation operations</li>
                        <li><b>Flexible Reporting:</b> Create custom reports and data sets from all cultivation activities</li>
                        <li><b>Herbicide & Pesticide Tracking:</b> Manage chemical application activity</li>
                        <li><b>Fertilizer & Mowing Tracking:</b> Manage fertilizer application & mowing activity</li>
                        <li><b>Tree and Replanting Management:</b> Manage nursery inventory and replanting activities</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
          }
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    chemicalList: state.cultivation.chemical.chemicalList,
    docs: state.cultivation.utils.docs,
    managers: state.cultivation.utils.managers
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchChemicals,
    fetchManagers,
    setDocs
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(CultivationIntro);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/documentation/introduction.js